'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jss = require('jss');

var _jss2 = _interopRequireDefault(_jss);

var _jssCamelCase = require('jss-camel-case');

var _jssCamelCase2 = _interopRequireDefault(_jssCamelCase);

var _jssNested = require('jss-nested');

var _jssNested2 = _interopRequireDefault(_jssNested);

var _jssDefaultUnit = require('jss-default-unit');

var _jssDefaultUnit2 = _interopRequireDefault(_jssDefaultUnit);

var _jssVendorPrefixer = require('jss-vendor-prefixer');

var _jssVendorPrefixer2 = _interopRequireDefault(_jssVendorPrefixer);

var _Utility = require('./Utility');

var Utils = _interopRequireWildcard(_Utility);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    buttonStyler1: function buttonStyler1(btnConfig) {
        if (Utils.isEmptyObj(btnConfig)) {
            return {
                "border-color": "#f07444",
                "background-color": "#F07444",
                // "text-shadow"      : "0 -1px 0 rgba(0, 0, 0, 0.25)",
                "color": "white",
                "&:hover": {
                    "background-color": "#ee622c",
                    // "box-shadow"       : "0 .125em rgba(255, 255, 255, .4), inset 0 .063em rgba(255, 255, 255, .4), inset 0 -.188em #e05719",
                    // "text-shadow"      : "0 -1px 0 #e45953",
                    "text-decoration": "none"
                },
                "&:active": {
                    // "box-shadow"      : "0 0.063em rgba(255, 255, 255, 0.4), inset 0 0 1.094em #141f0b, inset 0 0.063em #446927, inset 0 -0.188em #446927",
                    "text-decoration": "none"
                }
            };
        }
        return btnConfig;
    },
    backgroundStyler: function backgroundStyler(accentColor) {
        if (Utils.isEmptyObj(accentColor)) {
            return {
                "background-color": "#D03F02 !important",
                "border": "1px solid #f07444 !important"
            };
        } else {
            return {
                "background-color": accentColor + ' !important',
                "border": '1px solid ' + accentColor + ' !important'
            };
        }
    },
    backgroundStylerFocus: function backgroundStylerFocus(accentColor) {
        if (Utils.isEmptyObj(accentColor)) {
            return {
                "background-color": "#D03F02",
                "border": "1px solid #f07444",
                "color": "#ffffff"
            };
        } else {
            return {
                "background-color": accentColor,
                "border": '1px solid ' + accentColor,
                "color": "#ffffff"
            };
        }
    },
    backgroundStylerFocus5: function backgroundStylerFocus5(accentColor) {
        if (Utils.isEmptyObj(accentColor)) {
            return {
                "border-bottom": "2px solid #0a179c"
                // "border"           : "1px solid #f07444",
                // "color" : "#ffffff"
            };
        } else {
            return {
                "border-bottom": '2px solid ' + accentColor
                // "border"           : `1px solid ${accentColor}`,
                // "color" : "#ffffff"
            };
        }
    },
    backgroundStylerFocus2: function backgroundStylerFocus2(accentColor) {
        if (Utils.isEmptyObj(accentColor)) {
            return {
                "&:focus": {
                    "background-color": "#D03F02",
                    "border": "1px solid #f07444"
                    // "color" : "#ffffff"
                }
            };
        } else {
            return {
                "&:focus": {
                    "background-color": accentColor,
                    // "background" : accentColor,
                    "border": '1px solid ' + accentColor
                    // "color" : "#ffffff"
                }

            };
        }
    },
    customBtnOutlinePrimary: function customBtnOutlinePrimary(accentColor) {
        if (Utils.isEmpty(accentColor)) {
            return {
                "border": "1px solid #D03F02 !important",
                "color": "#D03F02",
                "background ": "#FFFFFF !imporant",
                "&:hover": {
                    "background-color": "#ee622c !important",
                    "border": "1px solid #ee622c !important",
                    "color": "#ffffff !imporant"
                },
                "&:active": {
                    "background-color": "#ee622c !important",
                    "border": "1px solid #ee622c !important",
                    "color": "#ffffff !imporant"
                }
            };
        } else {
            return {
                "border": "1px solid " + accentColor + " !important",
                "color": accentColor,
                "background ": "#FFFFFF !imporant",
                "&:hover": {
                    "background-color": accentColor + " !important",
                    "border": "1px solid " + accentColor + " !important",
                    "color": "#ffffff !imporant"
                },
                "&:active": {
                    "background-color": accentColor + " !important",
                    "border": "1px solid " + accentColor + " !important",
                    "color": "#ffffff !imporant"
                }
            };
        }
    },
    setAccentColor: function setAccentColor(accentColor) {
        if (Utils.isEmpty(accentColor)) {
            return {
                "color": "#D03F02 !important",
                "&:hover": {
                    "color": "#ffffff !imporant"
                },
                "&:active": {
                    "color": "#ffffff !imporant"
                }
            };
        } else {
            return {
                "color": accentColor + " !important",
                "&:hover": {
                    "color": "#ffffff !imporant"
                },
                "&:active": {
                    "color": "#ffffff !imporant"
                }
            };
        }
    },
    customHeartButtonOutlinePrimary: function customHeartButtonOutlinePrimary(accentColor) {
        if (Utils.isEmpty(accentColor)) {
            return {
                "border-color": "#D03F02",
                "background ": "#FFFFFF",
                "&:hover": {
                    "border-color": "#ccc"
                }
            };
        } else {
            return {
                "border-color": accentColor,
                "background ": "#FFFFFF",
                "&:hover": {
                    "border-color": "#ccc"
                }
            };
        }
    },
    customHeaderBtnActive: function customHeaderBtnActive(accentColor) {
        if (Utils.isEmpty(accentColor)) {
            return {
                "background-color": "#D03F02",
                "color": "#FFFFFF",
                "padding": "5px 12px",
                "border-radius": "1000px",
                "font-weight": "600"
            };
        } else {
            return {
                "background-color": accentColor,
                "color": "#FFFFFF",
                "padding": "5px 12px",
                "border-radius": "1000px",
                "font-weight": "600"
            };
        }
    },
    customMenuBtnActive: function customMenuBtnActive(accentColor) {
        if (Utils.isEmpty(accentColor)) {
            return {
                "background-color": "#ee622c !important",
                "border-color": "#ee622c !important",
                "color": "#ffffff !important"
            };
        } else {
            return {
                "background-color": accentColor + " !important",
                "border-color": accentColor + " !important",
                "color": "#ffffff !important"
            };
        }
    },
    customParentalMenuBtnActive: function customParentalMenuBtnActive(accentColor) {
        if (Utils.isEmpty(accentColor)) {
            return {
                // "background-color" : "#ee622c !important",
                "border-bottom": "3px solid #ee622c !important",
                "color": "#ee622c !important"
            };
        } else {
            return {
                // "background-color": accentColor + " !important",
                "border-bottom": "3px solid " + accentColor + " !important",
                "color": accentColor + " !important"
            };
        }
    },
    customParentalMenuBtnHoverActive: function customParentalMenuBtnHoverActive(accentColor) {
        if (Utils.isEmpty(accentColor)) {
            return {
                "&:hover": {
                    "border-bottom": "3px solid #ee622c !important",
                    "color": "#ee622c !important"
                },
                "&:active": {
                    "border-bottom": "3px solid #ee622c !important",
                    "color": "#ee622c !important"
                },
                "&:focus": {
                    "border-bottom": "3px solid #ee622c !important",
                    "color": "#ee622c !important"
                }
            };
        } else {
            return {
                "&:hover": {
                    "border-bottom": "3px solid " + accentColor + " !important",
                    "color": accentColor + " !important"
                },
                "&:active": {
                    "border-bottom": "3px solid " + accentColor + " !important",
                    "color": accentColor + " !important"
                },
                "&:focus": {
                    "border-bottom": "3px solid " + accentColor + " !important",
                    "color": accentColor + " !important"
                }
            };
        }
    },
    customLocationDropdown: function customLocationDropdown(accentColor) {
        if (Utils.isEmpty(accentColor)) {
            return {
                "border-top": "2px solid #ee622c !important"
            };
        } else {
            return {
                "border-top": "2px solid " + accentColor + " !important"
            };
        }
    },
    customMenuBtnHoverActive: function customMenuBtnHoverActive(accentColor) {
        if (Utils.isEmpty(accentColor)) {
            return {
                "&:hover": {
                    "background-color": "#ee622c !important",
                    "border-color": "#ee622c !important",
                    "color": "#ffffff !important"
                },
                "&:active": {
                    "background-color": "#ee622c !important",
                    "border-color": "#ee622c !important",
                    "color": "#ffffff !important"
                },
                "&:focus": {
                    "background-color": "#ee622c !important",
                    "border-color": "#ee622c !important",
                    "color": "#ffffff !important"
                }
            };
        } else {
            return {
                "&:hover": {
                    "background-color": accentColor + " !important",
                    "border-color": accentColor + " !important",
                    "color": "#ffffff !important"
                },
                "&:active": {
                    "background-color": accentColor + " !important",
                    "border-color": accentColor + " !important",
                    "color": "#ffffff !important"
                },
                "&:focus": {
                    "background-color": accentColor + " !important",
                    "border-color": accentColor + " !important",
                    "color": "#ffffff !important"
                }
            };
        }
    },
    radioStyler: function radioStyler(accentColor) {
        if (Utils.isEmptyObj(accentColor)) {
            return {
                "background-color": "#2196F3",
                "border": "1px solid #2196F3"
            };
        } else {
            return {
                "background-color": accentColor,
                "border": "1px solid " + accentColor
            };
        }
    },
    checkboxStyler: function checkboxStyler(accentColor) {
        if (Utils.isEmptyObj(accentColor)) {
            return {
                "background-color": "#2196F3",
                "border": "1px solid #2196F3"
            };
        } else {
            return {
                "background-color": accentColor,
                "border": "1px solid " + accentColor
            };
        }
    },
    activeBgStyler: function activeBgStyler(accentColor) {
        if (Utils.isEmptyObj(accentColor)) {
            return {
                "background-color": "#f07444 !important",
                "color": "white !important",
                "font-weight": "600",
                "border": "1px solid #f07444",
                "&:hover": {
                    "background-color": "#ee622c",
                    "text-decoration": "none",
                    "color": "white !important",
                    "text-shadow": "none",
                    "opacity": "0.95"
                },
                "&:focus": {
                    "color": "white !important"
                }
            };
        } else {
            return {
                "color": "white !important",
                "font-weight": "600",
                "background-color": accentColor + ' !important',
                "border": '1px solid ' + accentColor,
                "&:hover": {
                    "color": "white !important",
                    "background-color": accentColor,
                    "text-decoration": "none",
                    "text-shadow": "none",
                    "opacity": "0.95"
                },
                "&:focus": {
                    "color": "white !important"
                }
            };
        }
    },
    colorStyler: function colorStyler(accentColor) {
        if (Utils.isEmptyObj(accentColor)) {
            return {
                "color": "#D03F02 !important"
            };
        } else {
            return {
                "color": accentColor + ' !important'
            };
        }
    },
    getButtonStyleType1: function getButtonStyleType1(sheet, btnConfig) {
        sheet.addRule('.btn-styl', this.buttonStyler1(btnConfig), { named: false });
        return sheet;
    },
    getRadioButtonStyleType: function getRadioButtonStyleType(sheet, accentColor) {
        sheet.addRule('.container-radio input:checked ~ .checkmark-radio', this.radioStyler(accentColor), { named: false });
        return sheet;
    },
    getCheckBoxStyleType: function getCheckBoxStyleType(sheet, accentColor) {
        sheet.addRule('.container-checkbox input:checked ~ .checkmark', this.checkboxStyler(accentColor), { named: false });
        return sheet;
    },
    getButtonStyleTypeNew1: function getButtonStyleTypeNew1(sheet, accentColor) {
        sheet.addRule('.btn-default', this.backgroundStylerFocus2(accentColor), { named: false });
        return sheet;
    },
    getButtonStyleOutline: function getButtonStyleOutline(sheet, accentColor) {
        sheet.addRule('.custom-btn-outline-primary', this.customBtnOutlinePrimary(accentColor), { named: false });
        return sheet;
    },
    getButtonStyleImp: function getButtonStyleImp(sheet, accentColor) {
        sheet.addRule('.custom-primary', this.setAccentColor(accentColor), { named: false });
        return sheet;
    },
    getHeartButtonOutline: function getHeartButtonOutline(sheet, accentColor) {
        sheet.addRule('.heart-active', this.customHeartButtonOutlinePrimary(accentColor), { named: false });
        return sheet;
    },
    getHeaderButtonStyleActive: function getHeaderButtonStyleActive(sheet, accentColor) {
        sheet.addRule('.header-btn-active', this.customHeaderBtnActive(accentColor), { named: false });
        return sheet;
    },
    getMenuButtonStyleActive: function getMenuButtonStyleActive(sheet, accentColor) {
        sheet.addRule('.sub-parent-active', this.customMenuBtnActive(accentColor), { named: false });
        return sheet;
    },
    getParentalSubMenuButtonStyleActive: function getParentalSubMenuButtonStyleActive(sheet, accentColor) {
        sheet.addRule('.btn-parental-dropdown', this.customParentalMenuBtnActive(accentColor), { named: false });
        return sheet;
    },
    getParentalMenuButtonStyleActive: function getParentalMenuButtonStyleActive(sheet, accentColor) {
        sheet.addRule('.nav-link-active', this.customParentalMenuBtnActive(accentColor), { named: false });
        return sheet;
    },
    getParentalMenuButtonStyleHoverActive: function getParentalMenuButtonStyleHoverActive(sheet, accentColor) {
        sheet.addRule('.parental-nav-link', this.customParentalMenuBtnHoverActive(accentColor), { named: false });
        return sheet;
    },
    getLocationDropdownStyle: function getLocationDropdownStyle(sheet, accentColor) {
        sheet.addRule('.location-dropdown', this.customLocationDropdown(accentColor), { named: false });
        return sheet;
    },
    getMenuButtonStyleHoverActive: function getMenuButtonStyleHoverActive(sheet, accentColor) {
        sheet.addRule('.sub-parent-nav-link', this.customMenuBtnHoverActive(accentColor), { named: false });
        return sheet;
    },
    getCreditTablinkActiveStyle: function getCreditTablinkActiveStyle(sheet, accentColor) {
        sheet.addRule('.credit-tablink-active', this.backgroundStylerFocus5(accentColor), { named: false });
        return sheet;
    },
    getBackgroundStyleType1: function getBackgroundStyleType1(sheet, accentColor) {
        sheet.addRule('.bg-styl', this.backgroundStyler(accentColor), { named: false });
        return sheet;
    },
    getActiveBackgroundStyleType1: function getActiveBackgroundStyleType1(sheet, accentColor) {
        sheet.addRule('.active-styl', this.activeBgStyler(accentColor), { named: false });
        return sheet;
    },
    getColorStyleType1: function getColorStyleType1(sheet, accentColor) {
        sheet.addRule('.color-styl', this.colorStyler(accentColor), { named: false });
        return sheet;
    },
    generateGlobalStyleSheet: function generateGlobalStyleSheet(websiteConfig) {
        // console.log("Load the style generator")

        _jss2.default.use((0, _jssDefaultUnit2.default)());
        _jss2.default.use((0, _jssVendorPrefixer2.default)());
        _jss2.default.use((0, _jssNested2.default)());

        var sheet = _jss2.default.createStyleSheet({}, { named: false });

        this.getButtonStyleType1(sheet, websiteConfig.btnConfig);
        this.getBackgroundStyleType1(sheet, websiteConfig.accentColor);
        this.getActiveBackgroundStyleType1(sheet, websiteConfig.accentColor);
        this.getColorStyleType1(sheet, websiteConfig.accentColor);
        this.getRadioButtonStyleType(sheet, websiteConfig.accentColor);
        this.getCheckBoxStyleType(sheet, websiteConfig.accentColor);
        this.getButtonStyleTypeNew1(sheet, websiteConfig.accentColor);
        this.getCreditTablinkActiveStyle(sheet, websiteConfig.accentColor);
        this.getButtonStyleOutline(sheet, websiteConfig.accentColor);
        this.getButtonStyleImp(sheet, websiteConfig.accentColor);
        this.getHeartButtonOutline(sheet, websiteConfig.accentColor);
        this.getHeaderButtonStyleActive(sheet, websiteConfig.accentColor);
        this.getMenuButtonStyleActive(sheet, websiteConfig.accentColor);
        this.getParentalSubMenuButtonStyleActive(sheet, websiteConfig.accentColor);
        this.getParentalMenuButtonStyleActive(sheet, websiteConfig.accentColor);
        this.getParentalMenuButtonStyleHoverActive(sheet, websiteConfig.accentColor);
        this.getLocationDropdownStyle(sheet, websiteConfig.accentColor);

        sheet.attach();
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/StyleGenerator.jsx
// module id = 322
// module chunks = 0